<template>
  <div>
    <div class="text-left">{{ itemClass }}</div>
    <textarea
        rows="8"
        dir="ltr"
        v-model="textAreaValue"
        class="form-control text-left"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "ClassBoxScss",
  props: {
    itemClass: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      textAreaValue: '',
      isSyncing: false, // پرچم برای جلوگیری از لوپ
    };
  },
  computed: {
    globalCss() {
      return this.$store.getters['Site/getGlobalStyle'];
    }
  },
  methods: {
    extractBlockFromCss(css) {
      const className = this.itemClass.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const regex = new RegExp(`(\\.${className}(::[a-zA-Z0-9_-]+)?\\s*\\{[\\s\\S]*?\\})`, 'm');
      const match = css.match(regex);
      return match ? match[1].trim() : '';
    },
    globalToClassBox() {
      this.isSyncing = true;
      this.textAreaValue = this.extractBlockFromCss(this.globalCss);
      this.isSyncing = false;
    },
    boxToGlobal() {
      if (this.isSyncing || !this.textAreaValue.trim()) return;

      const selectorMatch = this.textAreaValue.match(/^([^\{]+)\{/m);
      if (!selectorMatch) return;

      const selector = selectorMatch[1].trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const blockRegex = new RegExp(`(${selector}\\s*\\{[\\s\\S]*?\\})`, 'm');

      let updatedCss;

      if (blockRegex.test(this.globalCss)) {
        updatedCss = this.globalCss.replace(blockRegex, this.textAreaValue.trim());
      } else {
        updatedCss = `${this.globalCss.trim()}\n\n${this.textAreaValue.trim()}`;
      }

      if (updatedCss !== this.globalCss) {
        this.isSyncing = true;
        this.$store.commit('Site/setGlobalStyle', updatedCss);
        this.isSyncing = false;
      }
    }
  },
  mounted() {
    this.globalToClassBox();
  },
  watch: {
    globalCss() {
      this.globalToClassBox();
    },
    textAreaValue() {
      this.boxToGlobal();
    }
  },
};
</script>

<style scoped></style>
